
import React from 'react';

const TriangleIcon = ({
  color = 'red',
  width = '8px',
  height = '8px',
  className
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill={color}
    className={className}
  >
    <path d="M3 111.67L247.67 418.4c4 5.06 12.6 5.06 16.65 0L509 111.64a15.21 15.21 0 002.2-13.9 14.2 14.2 0 00-1-2.32 10.66 10.66 0 00-9.39-5.62H11.14a10.64 10.64 0 00-9.38 5.62 13.93 13.93 0 00-1 2.27A15.26 15.26 0 003 111.67z" />
  </svg>
);

export default TriangleIcon;
